import { AuthService } from './AuthService';
import { BASIS_COMPARE_LIMIT, PREMIUM_COMPARE_LIMIT } from './constants/pricingFeatures';

export const PENDING_COMPARISON_KEY = 'pendingComparisonAdd';

export function compareLimitForUser(user) {
  if (AuthService.isPremiumActiveUser(user)) return PREMIUM_COMPARE_LIMIT;
  if (!user) return 0;
  return BASIS_COMPARE_LIMIT;
}

export function basketLimitForUser(user, paymentEnabled = true) {
  if (!paymentEnabled || AuthService.isPremiumActiveUser(user)) return PREMIUM_COMPARE_LIMIT;
  if (!user) return 0;
  return BASIS_COMPARE_LIMIT;
}

export function selectionBlockReason(user, currentCount, addedCount, paymentEnabled = true) {
  if (!addedCount || !paymentEnabled) return null;
  const limit = compareLimitForUser(user);
  if (currentCount + addedCount <= limit) return null;
  return user ? 'limit' : 'auth';
}

export function readPendingComparisonAdd() {
  try {
    const raw = sessionStorage.getItem(PENDING_COMPARISON_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function storePendingComparisonAdd(institution) {
  try {
    if (!institution) {
      sessionStorage.removeItem(PENDING_COMPARISON_KEY);
      return;
    }
    sessionStorage.setItem(PENDING_COMPARISON_KEY, JSON.stringify(institution));
  } catch {
    /* storage unavailable */
  }
}

export function clearPendingComparisonAdd() {
  try {
    sessionStorage.removeItem(PENDING_COMPARISON_KEY);
  } catch {
    /* storage unavailable */
  }
}
